import { productActions, shopActions } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { assets } from "../../assets";
import s from "./index.module.css";
import {
  Banner,
  ActionButtons,
  SearchBar,
  ProductList,
  Loader,
  ShopFooter,
  CompanyLogo,
} from "../../components";

export function Shop() {
  const { shop, product } = useSelector((state) => state);
  const [searchValue, setSearchValue] = useState("");
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();

  const pageUrl = typeof window !== "undefined" ? window.location.href : "";

  // Get Public Shop
  useEffect(() => {
    let shop_id = null;
    try {
      shop_id = Number(atob(params.shop_id));
    } catch (e) {
      setError(true);
    }

    if (shop_id) {
      dispatch(shopActions.getPublicShop(shop_id));
      dispatch(shopActions.getPublicShopConfig(shop_id));
    } else {
      setError(true);
    }
  }, []);

  // Handle Shop Status
  useEffect(() => {
    if (shop.status === "GET_PUBLIC_SHOP_ERROR") {
      setError(true);
    } else if (shop.status === "GET_PUBLIC_SHOP_SUCCESS") {
      setTitle(shop.detail);
      setError(false);
      dispatch(productActions.getProductsOfPublicShop(shop.detail?.shop_id));
    } else if (shop.status === "GET_PUBLIC_SHOP_REQUEST") {
      setError(false);
    }
  }, [shop]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const setTitle = (detail = {}) => {
    const { name, category } = detail;
    let title = `${name || ""} ${name ? "-" : ""} ${category || ""} ${category ? "-" : ""} SOLO`;
    document.title = title;
  };

  const mapLink =
    shop.detail?.latitude && shop.detail?.longitude
      ? `https://www.google.com/maps?q=${shop.detail.latitude},${shop.detail.longitude}`
      : "";

  // Render Shop
  if (shop.status === "GET_PUBLIC_SHOP_REQUEST") {
    return (
      <div className={s.loaderArea}>
        <Loader width={200} height={200} />
      </div>
    );
  } else if (shop.status === "GET_PUBLIC_SHOP_SUCCESS") {
    return (
      <div className={`${s.shop} ${shop.config.review_link || shop.detail?.upi_id ? s.footer_cta_available : ""}`}>
        <Banner
          data={shop.detail}
          website={shop.detail.website}
          mapLink={mapLink}
          pageUrl={pageUrl}
          config={shop.config}
        />
        <ActionButtons data={shop.detail}>
          <SearchBar onKeyChange={handleSearchChange} />
        </ActionButtons>
        <ProductList
          data={product.list}
          shopInfo={shop.detail}
          status={product.status}
          searchValue={searchValue}
        />
        <ShopFooter shopInfo={shop.detail} config={shop.config}/>
        <div className={s.companylogo}>
          <CompanyLogo />
        </div>
      </div>
    );
  } else if (error) {
    return (
      <div className={s.noShopArea}>
        <img src={assets.unavailable} alt="" className={s.noShopImage} />
        <p className={s.noshopText}>Shop you are looking for is unavailable.</p>
        <Link to="/" className={s.homeLink}>
          Back to Home
        </Link>
      </div>
    );
  } else {
    return null;
  }
}
